<template>
    <div id="editor_textContext">
        <div class="editor_text">
            <div class="editor_text1">
                <div class="editor_text2">字数 {{ textContentLength }}</div>
                <textLoading v-if="streamStatus"></textLoading>
            </div>
            <div class="editor_textContext1">
                <div class="cursor_1 chapter-zw-gray t-m-r-10" @click="copyInnterText">
                    <i class="el-icon-document-copy t-m-r-5"></i>
                    复制正文
                </div>
                <div class="cursor_1 chapter-zw-gray t-m-r-10" v-if="!editorStatus" @click="openLookPrveText">
                    <i class="el-icon-view t-m-r-5"></i>
                    查看上章
                </div>
                <div class="cursor_1 chapter-zw-blur" v-if="[1].includes(btnStatus) && editorStatus" @click="editor">编辑
                </div>
                <div class="cursor_1 chapter-zw-blur" v-if="!editorStatus" @click="save(2)">
                    <svg-icon iconClass="cg" class="custom t-m-r-5" />
                    保存草稿
                </div>
                <div class="cursor_1 t-m-l-10  chapter-zw-blur" v-if="!editorStatus" @click="save(1)">
                    <svg-icon iconClass="save" class="custom t-m-r-5" />
                    保存章节
                </div>
            </div>
        </div>

        <div class="editor_textContext2" ref="editorTextContext2">
            <div class="editor_textContext2_1 t-m-b-15">{{ overviewTitle }}</div>
            <editBox v-if="!streamStatus" v-model="markedContent" :isDisabled="editorStatus"></editBox>
            <!-- <textarea   v-if="!streamStatus" v-model="markedContent" :disabled="editorStatus" placeholder="请输入正文内容或选择AI生成"
                style="width: 100%;height: 100%;white-space: pre-wrap;"></textarea> -->
            <div class="editor_textContext2_2" v-else v-html="markedContent">
            </div>
        </div>
        <div class="editor_textContext3" v-if="!editorStatus">
            <div style="">
                <div class="btn-array-1">
                    <div class="cursor_1 btn_item" @click="againText()">
                        <img src="@/assets/image/ai_outline/1.png" />
                        <span class="t-p-l-5">换一换</span>
                    </div>
                    <div class="cursor_1 btn_item" @click="openCorrect">
                        <img src="@/assets/image/ai_outline/2.png" />
                        <span class="t-p-l-5">正文修正</span>
                    </div>
                    <div class="cursor_1 btn_item" @click="openWriteBack">
                        <img src="@/assets/image/ai_outline/3.png" />
                        <span class="t-p-l-5">正文仿写</span>
                    </div>
                    <div class="cursor_1 btn_item" @click="openRewrite">
                        <img src="@/assets/image/ai_outline/4.png" />
                        <span class="t-p-l-5">正文改写</span>
                    </div>
                    <div class="cursor_1 btn_item" @click="openElaborate">
                        <img src="@/assets/image/ai_outline/5.png" />
                        <span class="t-p-l-5">正文扩写</span>
                    </div>
                    <div class="cursor_1 btn_item" @click="openpolish">
                        <img src="@/assets/image/ai_outline/6.png" />
                        <span class="t-p-l-5">小说润色</span>
                    </div>
                    <div class="cursor_1 btn_item" @click="openTrace">
                        <img src="@/assets/image/ai_outline/7.png" />
                        <span class="t-p-l-5">AI去痕迹</span>
                    </div>
                </div>
            </div>

        </div>
        <!-- 停止生成按钮 -->
        <div style="width: 100%;position: relative;">
            <AIStopCreate :hide="streamStatus" bottom="80px"></AIStopCreate>
        </div>
        <editorTrace ref="editorTrace"></editorTrace>
        <editorPolish ref="editorPolish"></editorPolish>
        <editorRewrite ref="editorRewrite"></editorRewrite>
        <editorElaborate ref="editorElaborate"></editorElaborate>
        <editorCorrect ref="editorCorrect" length="短"></editorCorrect>
        <editorLookChapter ref="editorLookChapter"></editorLookChapter>
        <editorImitativeWriting ref="editorImitativeWriting"></editorImitativeWriting>
        <textRequire ref="textRequire"></textRequire>
        <delPopup ref="delPopup"></delPopup>
        <LoadingRecall :visible.sync="recallLoading" :novelId="editItem.id" novelType="novel"></LoadingRecall>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus'
import { copy } from '@/utils/utils'
import editBox from '@/components/edit_box.vue' // 文本编辑框
import editorPolish from '@/components/editor_polish.vue' // 润色
import editorRewrite from '@/components/editor_rewrite.vue' // 正文改写
import editorElaborate from '@/components/editor_elaborate.vue' // 正文扩写
import editorTrace from '@/components/editor_trace.vue'// AI去痕
import editorCorrect from '@/components/editor_correct.vue'// 正文修正
import editorLookChapter from '@/components/editor_lookchapter.vue'// 查看上一章
import editorImitativeWriting from '@/components/editor_imitativeWriting.vue'// 正文仿写
import textRequire from '@/components/text_require.vue'// 要求
import delPopup from './del_popup.vue';
import textLoading from './text_loading.vue';
import LoadingRecall from '@/components/dongeb/LoadingRecall'
import api from '@/api/api'
import _ from 'lodash'
export default {
    components: {
        editBox,
        editorPolish,
        editorRewrite,
        editorElaborate,
        editorTrace,
        textRequire,
        delPopup,
        textLoading,
        editorCorrect,
        editorLookChapter,
        editorImitativeWriting,
        LoadingRecall
    },
    data() {
        return {
            placeholder: '请输入正文',
            headStatus: false, // 手写 -- > ai生成状态
            editorStatus: true, // 1状态 编辑状态 true不可编辑  false可编辑
            ifeditorStatus: false, //是否点过编辑
            streamStatus: false, // 流式请求 false请求结束 true请求
            streamIndex: 0, // 流式请求下标
            streamLast: false, //流式最后一条
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            content: "",
            markedContent: '',
            overviewTitle: '',//文章标题
            btnStatus: null, // 1编辑 2手写 3AI生成
            contentText: '',
            editItem: JSON.parse(sessionStorage.getItem('editItem')), //编辑信息
            textrequire: '',//正文要求
            ifContent: false, //是否有正文
            isStop: false //是否停止
            // zwItem: null,//正文请求数据
        }
    },
    computed: {
        // 计算去除 HTML 标签后的文本长度
        textContentLength() {
            console.log('中短篇正文纯文字统计')
            return this.removeMarkdownTags(this.markedContent)
        }
    },
    mounted() {
        // 禁止
        EventBus.$on('disable', () => {
            this.editorStatus = true
        })
        // 手写
        EventBus.$on('headWrite', () => {
            this.editorStatus = false
        })

        // 替换
        EventBus.$on('replace', (data) => {
            //替换所有
            if (data?.all) {
                console.log('data=',data)
                this.markedContent = data.content
                this.$message.success('替换成功')
                return
            }
            // console.log('复制的内容=');
            // console.log(data.text)
            let conent = this.stripHtmlTags(this.markedContent) || ''
            // console.log('原内容：', conent)
            // console.log('复制的内容：', data.text)
            // console.log('生成结果：', data.content)
            // console.log(this.findDifferences(conent, data.text));
            // console.log(conent.trim() === data.text.trim())
            //进行判断复制的内容是否在富文本存在
            const isSimilar = _.includes(conent.trim(), data.text.trim());
            console.log('isSimilar=', isSimilar)
            if (isSimilar) {
                // console.log('替换后=',conent.replace(regex, `<span style="color: red !important;">${data.content}</span>`))
                this.markedContent = conent.replace(data.text.trim(), `<span style="color: red !important;">${data.content}</span>`)
                this.$message.success('替换成功')
            } else {
                this.$message.warning('请先保存未找到要替换的内容，无法进行替换。')
            }
        })
        //换一换，下一步都是这个去监听
        EventBus.$on('getRequire', (item, type) => {
            //换一换 初始化取消ai生成的状态
            this.isStop = false
            this.textrequire = item
            this.again(type)
        })
    },
    beforeDestroy() {
        EventBus.$off('replace');
        EventBus.$off('disable');
        EventBus.$off('headWrite');
        EventBus.$off('getRequire');
        this.clearTimer()
    },
    created() {
        const editItem = JSON.parse(sessionStorage.getItem('editItem'))
        // console.log(editItem)
        if (editItem.id) {
            this.getUserLoginState(false)
            this.mixinNovelInfo(editItem.id)
            this.btnStatus = editItem?.editText
            this.chapter = editItem?.chapter
            // console.log('btnStatus=', this.btnStatus)
            if (this.btnStatus === 2) {
                // 手写
                this.editorStatus = false
            } else if (this.btnStatus === 1) {
                //编辑
                this.editorStatus = true
                this.getNovelContent()
            } else if (this.btnStatus === 3) {
                //ai生成
                this.editorStatus = true
                this.headStatus = true
            }
        } else {
            this.$message.warning('不支持多开页面进行操作')
            // setTimeout(() => {
            //     this.$router.push('/')
            //     window.history.back();
            //     window.location.href = 'about:blank'; // 跳转到空白页
            // }, 500);
        }
    },
    methods: {
        clearTimer(status) {
            console.log('销毁定时器')
            if (status) {
                this.isStop = true
            }
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
            this.streamStatus = false;
            this.streamLast = false;
            this.streamIndex = 0;
            sessionStorage.removeItem('streamStatus')
        },
        // 复制正文
        async copyInnterText() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            const success = await copy(this.stripHtmlTags(this.markedContent));
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
        // 获取正文
        getNovelContent() {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            console.log('获取正文是在这里？=', editItem)
            api.getNovelContent(editItem.textId).then((res) => {
                if (res.code == 200) {
                    this.content = res.data.textContent
                    // console.log('获取正文-----')
                    // console.log(this.content)
                    this.markedContent = res.data.textContent
                    this.overviewTitle = res.data.overviewTitle
                }
            })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.clearTimer()
                                    this.$message.success('AI生成完成！');
                                } else {
                                    this.getStreamContent(id);
                                }
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                }).catch(() => {
                    this.clearTimer()
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.content += text[index]
                    // this.markedContent = this.content.replace(/ +/g, (spaces) => {
                    //     return '&nbsp;'.repeat(spaces.length); // 按原空格数量替换
                    // });
                    this.markedContent = this.content
                    index++;
                    // this.$nextTick(() => {
                    //     const container = this.$refs.editorTextContext2;
                    //     if (container) {
                    //         container.scrollTop = container.scrollHeight; // 直接滚动到底部
                    //     }
                    // });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        // 手写 -- > ai生成状态
        // aiContent() {
        //     this.headStatus = true
        //     this.again('nxszw')
        // },
        // 2手写 编辑出现下边按钮
        inputContent() {
            this.editorStatus = false
        },
        // 编辑
        editor() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            //开启编辑之前先看章节概述开启了编辑没，如果开启了编辑，这里点击编辑的时候就会进行保存，注意，手写正文不用管
            if (this.btnStatus != 2) {
                EventBus.$emit('saveChapterContent')
            }
            //如果正文开启编辑了，章纲就要变成不可编辑
            if (this.editorStatus) {
                EventBus.$emit('disableChapter')
            }
            this.editorStatus = false
            if (!this.editorStatus) {
                sessionStorage.setItem('ifEditor', true)
                this.$refs.delPopup.openPrompt(6)
            }

        },
        // 保存 btnStatus
        save(status) {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            if (!this.markedContent.trim()) {
                this.$message.warning('正文内容不能为空!');
                return
            }
            //编辑
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            if (editItem)
                if (this.btnStatus == 1 && editItem?.textId) {
                    this.modifyNovelChapter(status)
                } else {
                    //手写和ai生成
                    this.addNovelChapter(status)
                }
        },
        //编辑修改章节
        modifyNovelChapter(status) {
            console.log('编辑=', this.markedContent);
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                name: editItem.chapterName,
                content: this.stripHtmlTags(this.markedContent),
                status: status,
                id: editItem.textId,
                // requirement: this.textrequire //要求
            }
            api.modifyNovelChapter(params).then((res) => {
                if (res.code == 200) {
                    this.editorStatus = true
                    this.content = params.content
                    //刷新替换后的字体颜色变成黑色
                    this.markedContent = params.content
                    this.$message.success(res.msg)
                    //更新小说章纲信息
                    this.chapterFind();
                    sessionStorage.setItem('ifEditor', false)
                    if (status == 1) {
                        this.recallSave()
                    }
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        //ai或者手写的保存
        addNovelChapter(status) {
            console.log('ai或者手写的保存=', this.markedContent);
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                novelId: editItem.id,
                content: this.stripHtmlTags(this.markedContent),
                episode: editItem.chapter,
                status: status,
                length: 8000,
                name: editItem.chapterName,
                requirement: this.textrequire
            }
            //获取章节的概述
            api.getoverview(editItem.id, editItem.chapterId).then((result) => {
                if (result.code === 200) {
                    params.overview = result.data && result.data.overview || '';
                    api.addNovelChapter(params).then((res) => {
                        if (res.code == 200) {
                            this.editorStatus = true
                            this.$message.success('添加章节成功')
                            this.content = params.content
                            //刷新替换后的字体颜色变成黑色
                            this.markedContent = params.content
                            //更新小说章纲信息
                            this.chapterFind();
                            sessionStorage.setItem('ifEditor', false)
                            if (status == 1) {
                                this.recallSave()
                            }

                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            });

        },
        //长记忆接口
        recallSave() {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            if (this.zsVip() && this.isOpenRecall(this.mixinNInfo)) {
                let recallPram = {
                    novelId: editItem.id,
                    type: 'novel',
                    chapter: editItem.chapter
                }
                this.recallLoading = true
                api.recallSave(recallPram).then(result => {
                    if (result.code === 200) {
                        this.recallLoading = false
                        this.$message.success('长记忆已完成')
                    } else {
                        this.recallLoading = false
                        this.$message.warning(res.msg)
                    }
                }).catch(() => {
                    this.recallLoading = false
                })
            }
        },
        //获取小说章节详情信息
        chapterFind() {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'))
            api.getChapterFind(editItem.id, editItem.chapter).then(res => {
                if (res.data && res.data.length > 0) {
                    //这块代码意思，如果第一次保存就要改变状态和textid的获取，没办法之前另一个前端大佬写的代码，按照他的逻辑走
                    editItem.textId = res.data[0].textId
                    this.editorStatus = true //变成只可编辑
                    //这个意思就是如果已经保存了返回就到章节列表
                    editItem.editText = 1
                    this.btnStatus = editItem.editText
                    this.chapter = editItem.chapter
                    sessionStorage.setItem('editItem', JSON.stringify(editItem))
                    EventBus.$emit('refresh')
                }

            })
        },
        //生成正文
        againText() {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            let oneType = ''
            if (editItem.chapter == 1) {
                oneType = editItem.novelInfo.length.includes('短') ? 'short_start_text' : 'medium_start_text'
            } else {
                //是专业vip还有用户已经开启了长记忆就走长记忆的流式
                if (this.zsVip() && this.isOpenRecall(this.mixinNInfo)) {
                    oneType = editItem.novelInfo.length.includes('短') ? 'short_recall_text' : 'medium_recall_text'
                } else {
                    oneType = editItem.novelInfo.length.includes('短') ? 'short_text' : 'medium_text'
                }
            }
            this.$refs.textRequire.openPrompt(oneType, '换一换')
        },
        // 换一换
        again(type) {
            this.content = '';
            this.markedContent = '';
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            let params = {
                chapter: editItem.chapter,
                novelId: editItem.id,
                requirement: this.textrequire ? this.textrequire : ''
            };
            this.AIWrite({
                length: '中',
                haveId: true,
                type: type,
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true;
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data);
                },
                warn: (res) => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                    this.$message.warning(res.msg)
                }
            })

            // api.novelHelpWriteId(oneType, params).then((res) => {
            //     if (res.code === 200) {
            //         this.streamStatus = true;
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data);
            //     } else {
            //         this.streamStatus = false
            //         sessionStorage.removeItem('streamStatus');
            //         this.$message.warning(res.msg)
            //     }
            // });

        },
        //打开正文仿写
        openWriteBack() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            let params = {
                content: this.stripHtmlTags(this.markedContent),
            }
            this.$refs.editorImitativeWriting.open(params)
        },
        // 打开Ai去痕迹
        openTrace() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.$refs.editorTrace.open()
        },
        // 打开润色
        openpolish() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.$refs.editorPolish.open()
        },
        //打开正文改写
        openRewrite() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.$refs.editorRewrite.open()
        },
        //打开正文扩写
        openElaborate() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.$refs.editorElaborate.open()
        },
        //查看上一章
        openLookPrveText() {
            if (sessionStorage.getItem('streamStatus') || this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            let params = {
                novelId: editItem.id,
                content: this.stripHtmlTags(this.markedContent),
                chapter: editItem.chapter,
                prevContent: '',
                title: editItem.chapterName,
                prevTitle: ''
            }
            if (editItem.chapter > 0) {
                api.getChapterFind(editItem.id, editItem.chapter - 1).then(async (res) => {
                    if (res.code == 200) {
                        let data = res.data[0]
                        params.prevContent = this.stripHtmlTags(data.textContent)
                        params.prevTitle = data.name
                        this.$refs.editorLookChapter.open(params)
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            } else {
                this.$message.warning('当前已经是第一章')
            }

        },
        // 打开正文修正
        async openCorrect() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            let params = {
                novelId: editItem.id,
                content: this.stripHtmlTags(this.markedContent),
                chapter: editItem.chapter,
                prevContent: '',
                title: editItem.chapterName,
                prevTitle: ''
            }
            //获取上一章的正文
            if (editItem.chapter > 0) {
                api.getChapterFind(editItem.id, editItem.chapter - 1).then(async (res) => {
                    if (res.code == 200) {
                        let data = res.data[0]
                        params.prevContent = this.stripHtmlTags(data.textContent)
                        params.prevTitle = data.name
                        this.$refs.editorCorrect.open(params)
                    } else {
                        this.$refs.editorCorrect.open(params)
                    }
                })
            } else {
                this.$refs.editorCorrect.open(params)
            }
        }
    }
}
</script>

<style scoped>
#editor_textContext {
    flex: 1;
    height: 100%;
    min-width: 730px;
    background: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px 8px 0 0;
    margin-left: 15px;
}

.editor_textContext1 {
    display: flex;
}

.editor_textContext1_2 {
    padding: 0 10px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    border: 1px solid var(--tech-primary);
    font-size: 15px;
    color: var(--tech-primary);
    cursor: pointer;
}

.copyText {
    height: 36px;
    padding: 0 10px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    /* background-color: var(--tech-primary); */
    /* color: #fff; */
    /* border: 1px solid var(--tech-primary); */
    color: var(--tech-primary);
    font-size: 15px;
    cursor: pointer;
}

.editor_textContext2 {
    width: 100%;
    height: calc(100% - 138px);
    padding: 15px 25px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_textContext2_2 {
    font-size: 17px;
    color: #111111;
    outline: none;
    white-space: pre-wrap;
}

.editor_textContext2_2:focus {
    border: none;
}

.editor_textContext3 {
    width: 100%;
    height: 69px;
    padding: 0 15px;
    background: #FFFFFF;
    /* border-top: 1px solid #EEEEEE; */
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_textContext2_1 {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
}

.editor_textContext2_1 .quill-editor p {
    font-size: 17px;
    color: #111111;
}

.editor_textContext3_1 {
    width: 183px;
    height: 38px;
    background: url('@/assets/image/icon_chapter4.png') no-repeat;
    background-size: 100% 100%;
    font-size: 15px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    margin-top: 10px;
    cursor: pointer;
}

.editor_textContext3_2 {
    width: 150px;
    height: 38px;
    line-height: 38px;
    color: #FFFFFF;
    background-color: #ff4e50;
    margin-right: 15px;
    font-size: 15px;
    margin-top: 10px;
    cursor: pointer;
    border-radius: 8px;
    text-align: center;
    position: relative;
}

.editor_textContext3_2 img {
    position: absolute;
    left: 0;
    top: -10px;
}

.editor_textContext3_3 {
    width: 150px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: var(--tech-primary);
    color: #FFFFFF;
    /* border: 1px solid var(--tech-primary); */
    /* color: var(--tech-primary); */
    margin-right: 15px;
    font-size: 15px;
    margin-top: 10px;
    cursor: pointer;
}

.custom {
    color: #fff;
    font-size: 16px;
}

.btn-array-1 {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    /* gap: 24px; */
}
</style>